export default "__VITE_ASSET__BPrnUU8A__"